// removed by extract-text-webpack-plugin
module.exports = {"breadcrumbs":"-QFz-","separator":"_2K1hn"};


//////////////////
// WEBPACK FOOTER
// ./app/components/breadcrumbs/breadcrumbs.scss
// module id = 1623
// module chunks = 0